import React from 'react';
import ScrollAnimation from "react-animate-on-scroll";
import { Link } from 'react-router-dom/cjs/react-router-dom.min';
// import HomeConsultingVideo from '../video/HomeConsultingVideo'; // Remove this

const HomeConsultationSplit = () => {
    return (
        <div className="rn-splite-style">
            <div className="split-wrapper">
                <div className="row no-gutters radius-10 align-items-center">
                    <div className="col-lg-12 col-xl-6 col-12">
                        {/* Replace video with image */}
                        <div className="image-container">
                            <img 
                                src="images/consulting-pwu.jpg" 
                                alt="Consulting Outcomes" 
                                className="img-fluid rounded"
                            />
                        </div>
                    </div>
                    <div className="col-lg-12 col-xl-6 col-12">
                        <div className="split-inner">
                            <ScrollAnimation 
                                animateIn="fadeInUp"
                                animateOut="fadeInOut"
                                animateOnce={true}>
                                <h4 className="title">Consulting Outcomes</h4>
                            </ScrollAnimation>
                            <ScrollAnimation 
                                animateIn="fadeInUp"
                                animateOut="fadeInOut"
                                animateOnce={true}>
                                <p className="description"></p>
                            </ScrollAnimation>
                            <ScrollAnimation 
                                animateIn="fadeInUp"
                                animateOut="fadeInOut"
                                animateOnce={true}>
                                <ol>
                                    <li> Achieve 100% clarity on your life, business, and income path within 1–3 sessions.</li>
                                    <li> Launch or restructure & scale your business with a 90-day custom action plan.</li>
                                    <li> Boost income by 2X–5X in 3–6 months through focused strategies.</li>
                                    <li> Eliminate self-doubt and unlock confidence with a proven mindset shift.</li>
                                    <li> Create 1–3 new income streams aligned with your skills and goals.</li>
                                </ol>
                            </ScrollAnimation>
                            <ScrollAnimation 
                                animateIn="fadeInUp"
                                animateOut="fadeInOut"
                                animateOnce={true}>
                                <div className="view-more-button mt--35">
                                    <Link className="btn-default" to="/consultent">SEE MORE</Link>
                                </div>
                            </ScrollAnimation>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default HomeConsultationSplit;
